module.exports = __webpack_public_path__ + "img/vehicle.16e0c06e.svg";